import { useEffect }      from 'react'
import { useFetch }       from 'hooks/fetch/useFetch'
import { useGet, useSetAtom }     from 'state/jotai'
import { _bootstrap}      from 'state/store.bootstrap'
import { BOOT }           from 'api/api'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { params_query } from 'state/store.global'

export const useFetch_Bootstrap = () => {
  const navigate            = useNavigate();
  const params              = useGet(params_query);
  const location            = useLocation();
  const { i18n:{language} } = useTranslation()
  const path                = location.pathname.split('/')
 
  const updateAtom   = useSetAtom(_bootstrap)
  const { D:data }   = useFetch({url:BOOT,file:'useFetch_Bootstrap.jsx'})
  const { Projects } = Object.keys(data || {}).length ? data : {};
  const state        = Object.keys(data || {}).length ? true : false

  const projectDropdown = {}
  const projectLanguage = data?.multiProjectOption ? [...new Set(data?.multiProjectOption[0]?.map( m => m.Language))] : [];

  // if the given path includes language which isn't proper then the page will redirect to default language path
  if(projectLanguage && projectLanguage?.length && !projectLanguage.includes(language)) {
    navigate(`/${projectLanguage[0]}/${path.slice(2).join('/')}${params.length ? params : ''}`, { replace: "true" });
  }

  // Multiproject dropdown adding as per different langauge 
  projectLanguage?.forEach(( lang ) => {
    projectDropdown[lang] = data.multiProjectOption[0].filter((m) => m.Language === lang).map((p, i) => {
      let projectData = Projects?.filter((pr) => pr.ProjectID === p.PID)
      if(projectData?.length > 0) return { ...p, PIN: i, available_Units: projectData[0]?.NoOfVacantUnits }
      return { ...p, PIN: i}
    } )
  })
  
  useEffect(()=>{
    if ( data ) {
      updateAtom({
        // type        : data.HasMap ? 'mono' : 'poly',
        type        : !data.HasMap ? 'poly' : 'mono',
        cdn         : data.CDNIsometry,
        openhouse   : data.ShowOpenHouseInfo,
        siteid      : data.SiteID,
        sitename    : data.SiteName,
        routes      : data.Router,
        startpage   : data.StartPage ?? `${language}/isometry`,
        dropdown    : data.Dropdown,
        // projectids  : [data?.ProjectIDs?.join(','), ...data.ProjectIDs],
        projectids  : data.ProjectIDs.length > 1 ? [[data?.ProjectIDs]?.join(','), ...data.ProjectIDs] : [data.ProjectIDs],
        projectnames: { ...projectDropdown },
        languages   : projectLanguage?.length ? projectLanguage : data?.Languages,
        projects    : data.Projects
      })
    }
  },[data])

  return state

}